import './App.css';
import Map from './components/Map';

function App() {
  return (
    <Map />
  );
}

export default App;
